module.exports = __webpack_public_path__ + "img/app-hjll.7b56c56e.webp";